"use strict";

exports.__esModule = true;
exports.default = void 0;

var _mediaSize = _interopRequireDefault(require("./mediaSize"));

var _mediaFormat = _interopRequireDefault(require("./mediaFormat"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "array",
  "items": {
    "type": "media",
    "properties": {
      "mediaSize": _mediaSize.default,
      "mediaFormat": _mediaFormat.default,
      "mediaLayout": {
        "type": "string",
        "default": "frame"
      },
      "content": {
        "type": "object",
        "properties": {
          "headline": {
            "type": "string"
          },
          "description": {
            "type": "string"
          },
          "creditLine": {
            "type": "string"
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;